const ethnicityOptions = [
  { label: 'White/Caucasian', value: 'white' },
  { label: 'African American', value: 'africanAmerican' },
  { label: 'Hispanic', value: 'hispanic' },
  { label: 'Asian', value: 'asian' },
];

export default ethnicityOptions;
